import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import ShareRow from "@/components/ShareRow";
import { Reveal, MaskLine } from "@/components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

const Faqs = () => (
  <>
    <SEO
      title="FAQs"
      path="/faqs"
      description="Frequently asked questions about Smart Nagar Nigam — the platform, Citizen Councillor Connect (C3), the Good Governance Book, the Delhi Ward Charter, the From Wards 2 the World Conclave, councillor assessment and partnership tiers."
    />
    <section className="relative overflow-hidden pt-28 md:pt-52" data-testid="faqs-hero">
      <div className="mx-auto max-w-[1600px] px-5 pb-16 md:px-10 md:pb-24">
        <MaskLine delay={0.1}>
          <span className="text-xs uppercase tracking-[0.2em] sm:tracking-[0.35em] text-gold md:text-sm">Frequently Asked Questions</span>
        </MaskLine>
        <h1 className="mt-6 font-display font-extrabold uppercase leading-[0.95] tracking-tight text-ivory">
          <MaskLine delay={0.25} className="text-[11vw] md:text-[7vw]">Answers, in Full.</MaskLine>
        </h1>
        <MaskLine delay={0.4}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
            Everything you need to know about the platform, the Conclave, C3, the Good
            Governance Book, and how to take part.
          </p>
        </MaskLine>
      </div>
    </section>

    <section className="border-t border-white/10" data-testid="faqs-list">
      <div className="mx-auto max-w-[1100px] px-5 py-16 md:px-10 md:py-24">
        <Reveal>
          <Accordion type="single" collapsible className="border border-white/10">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10 px-6 md:px-8">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display text-lg font-bold leading-snug text-ivory transition-colors duration-300 hover:text-gold md:text-xl"
                >
                  <span className="mr-4 text-sm font-bold tracking-[0.25em] text-gold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-sm leading-relaxed text-white/65 md:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap items-center gap-8">
            <Link to="/contact" data-testid="faqs-contact-cta" className="inline-flex items-center gap-3 bg-gold px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.15em] text-obsidian transition-colors duration-300 hover:bg-gold-light">
              Still Have a Question <ArrowRight size={16} />
            </Link>
            <ShareRow title="FAQs" path="/faqs" />
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Faqs;
